module.exports = __webpack_public_path__ + "img/venuetwo-jkxw-title.0c4e2053.png";